<template>
	<div class="btm_menu_bar">
		<div to="/" class="btm_menu" @click="setActiveMenu('Home')">
			<div class="icon_wrap">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="3rem"
					viewBox="0 96 960 960"
					width="3rem"
					:fill="activeMenu === 'Home' ? '#ca001b' : 'black'"
				>
					<path
						d="M220 876h150V626h220v250h150V486L480 291 220 486v390Zm0 60q-24.75 0-42.375-17.625T160 876V486q0-14.25 6.375-27T184 438l260-195q8.295-6 17.344-9 9.049-3 18.853-3 9.803 0 18.717 3 8.915 3 17.086 9l260 195q11.25 8.25 17.625 21T800 486v390q0 24.75-17.625 42.375T740 936H530V686H430v250H220Zm260-353Z"
					/>
				</svg>
			</div>
			<p :class="activeMenu === 'Home' ? 'active' : null">홈</p>
		</div>
		<div to="/mypage" class="btm_menu" @click="setActiveMenu('MyPage')">
			<div class="icon_wrap">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="3rem"
					viewBox="0 96 960 960"
					width="3rem"
					:fill="activeMenu === 'MyPage' ? '#ca001b' : 'black'"
				>
					<path
						d="M480 575q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42Zm260 321H220q-24.75 0-42.375-17.625T160 836v-34q0-38 19-65t49-41q67-30 128.5-45T480 636q62 0 123 15.5t127.921 44.694q31.301 14.126 50.19 40.966Q800 764 800 802v34q0 24.75-17.625 42.375T740 896Zm-520-60h520v-34q0-16-9.5-30.5T707 750q-64-31-117-42.5T480 696q-57 0-111 11.5T252 750q-14 7-23 21.5t-9 30.5v34Zm260-321q39 0 64.5-25.5T570 425q0-39-25.5-64.5T480 335q-39 0-64.5 25.5T390 425q0 39 25.5 64.5T480 515Zm0-90Zm0 411Z"
					/>
				</svg>
			</div>
			<p :class="activeMenu === 'MyPage' ? 'active' : null">마이페이지</p>
		</div>
		<div class="btm_menu" @click="setActiveMenu('Inventory')">
			<div class="icon_wrap">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 -960 960 960"
					fill="none"
					:stroke="activeMenu === 'Inventory' ? '#ca001b' : 'black'"
					stroke-width="50"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<!-- 창고 지붕 -->
					<path d="M120 -560 L480 -840 L840 -560" />

					<!-- 창고 벽 -->
					<path d="M200 -560 V -160 H760 V -560" />

					<!-- 위 박스 -->
					<rect x="360" y="-560" width="240" height="160" rx="20" />

					<!-- 아래 왼쪽 박스 -->
					<rect x="240" y="-400" width="200" height="160" rx="20" />

					<!-- 아래 오른쪽 박스 -->
					<rect x="520" y="-400" width="200" height="160" rx="20" />
				</svg>
			</div>
			<p :class="activeMenu === 'Inventory' ? 'active' : null">재고</p>
		</div>
		<div class="btm_menu" @click="setActiveMenu('Calendar')">
			<div class="icon_wrap" style="transform: scale(0.85)">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					height="2rem"
					viewBox="0 -960 960 960"
					width="2rem"
					:fill="activeMenu === 'Calendar' ? '#ca001b' : 'black'"
				>
					<path
						d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Z"
					/>
				</svg>
			</div>
			<p :class="activeMenu === 'Calendar' ? 'active' : null">캘린더</p>
		</div>
		<div class="btm_menu" @click="onClickLogout()">
			<div class="icon_wrap">
				<img src="@/assets/image/common/icon_logout.svg" alt="" />
			</div>
			<p>로그아웃</p>
		</div>
	</div>
</template>
<script setup>
	import { ref, watch } from 'vue';
	import { useRoute, useRouter } from 'vue-router';
	import { getToday, getLastDay } from '@/utils/dateCalculation';
	import store from '@/store';

	const router = useRouter();
	const route = useRoute();
	const activeMenu = ref(route.name || 'Home');

	const setActiveMenu = (name) => {
		if (name === 'Home') {
			// router.push('/');
			router.push({
				name: 'Home',
				query: {
					page: 1,
					filter_start_date: getToday(),
					filter_end_date: getLastDay(),
					state_type: '전체',
				},
			});
		} else if (name === 'MyPage') {
			router.push('/mypage');
		} else if (name === 'Inventory') {
			router.push('/inventory');
		} else if (name === 'Calendar') {
			router.push('/calendar');
		}
	};

	watch(route, () => {
		activeMenu.value = route.name;
	});
	const onClickLogout = () => {
		store.dispatch('user/LOGOUT');
	};
</script>
<style scoped src="@/assets/css/btm_menu_bar.css"></style>
